import { useEffect, useState } from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  useLoaderData,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./guest/Home";
import Counter from "./guest/Counter";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import OurHistory from "./guest/OurHistory";
import Vision from "./guest/Vision";
import WeValues from "./guest/WeValues";
import PrincipalMessage from "./guest/PrincipalMessage";
import PRO from "./guest/PRO";
import ProctorialBoard from "./guest/ProctorialBoard";
import Commitees from "./guest/Commitees";
import Parishad from "./guest/Parishad";
import IQAC from "./guest/IQAC";
import Rules from "./guest/Rules";
import RUSA from "./guest/RUSA";
import Faculty from "./guest/Faculty";
import Honors from "./guest/Honors";
import Publications from "./guest/Publications";
import AcademicCalendar from "./guest/AcademicCalendar";
import ListOfHoliday from "./guest/ListOfHoliday";
import Timetable from "./guest/Timetable";
import Courses from "./guest/Courses";
import TeachingPlan from "./guest/TeachingPlan";
import Seminar from "./guest/Seminar";
import Workshop from "./guest/Workshop";
import GuestLecture from "./guest/GuestLecture";
import UniversityExamination from "./guest/UniversityExamination";
import Research from "./guest/Research";
import BestPractices from "./guest/BestPractices";
import PageNotFound from "./guest/PageNotFound";
import ElearningPark from "./guest/ElearningPark";
import ELibrary from "./guest/ELibrary";
import Library from "./guest/Library";
import ComputerLab from "./guest/ComputerLab";
import WomenHealthClub from "./guest/WomenHealthClub";
import SmartClass from "./guest/SmartClass";
import MultiPurposeHall from "./guest/MultiPurposeHall";
import CollegeStore from "./guest/CollegeStore";
import Gallery from "./guest/Gallery";
import ContactUs from "./guest/ContactUs";
import RankingNirf from "./guest/RankingNirf";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import ScrollToTop from "./components/ScrollToTop";
import FeedbackForm from "./guest/FeedbackForm";
import AboutUsPage from "./guest/AboutUsPage";
import Events from "./guest/Events";
import Facility from "./guest/Facility";
import Syllabus from "./guest/Syllabus";
import Admission from "./guest/Admission";
import AdmissionRules from "./guest/AdmissionRules";
import LoginPage from "./components/studentPortal/LoginPage";
import SudentRegister from "./components/studentPortal/RegisterPage";
import Dashboard from "./components/studentPortal/Dashboard";
import PrivateRoute from "./components/studentPortal/PrivateRoute";
import AdmissionHomePage from "./components/AdmissionFom/AdmissionHomePage";
import AdmissionBaseLayout from "./components/AdmissionFom/AdmissionBaseLayout";
import PaymentPage from "./components/studentPortal/PaymentPage";
import FormPrivateRoute from "./components/studentPortal/FormPrivateRoute";
import Sucess from "./payments/Sucess";
import Fail from "./payments/Fail";
import AdmissionFormPrint from "./components/AdmissionFom/AdmissionFormPrint";
import PrintComponent from "./components/studentPortal/PrintChalan";
import OnlineFeeChallan from "./components/studentPortal/OnlineFeeChallan";
import { Token } from "@mui/icons-material";
import AdmissionPayment from "./components/studentPortal/AdmissionPayment";
import courses from "./components/AdmissionFom/courses";
import ForgotPass from "./components/ForgotPass";
import AdmissionPaymentReceipt from "./components/studentPortal/AdmissionPaymentReceipt";
import FacultiesDetails from "./components/FacultiesDetails";
import Adminlayout from "./layout/Adminlayout";
import Home2 from "./layout/New_Admission/Home";
import Profile from "./layout/New_Admission/Profile";
import Addmission from "./layout/New_Admission/Admission";
import Chalan from "./layout/New_Admission/Chalan";
import Support from "./layout/New_Admission/Support";

const AppContent = () => {
  const isAdmissionPage =
    window.location.toString().split("/")[4] == "admission-form";

  const [loading, setLoading] = useState(true);
  const [store, setStore] = useState();
  const [perc, setPerc] = useState(5);
  const [gealleryHeads, setGalleryHeads] = useState([]);
  const dispatch = useDispatch();
  const [streams, setStreams] = useState([]);

  // const studentDetails = JSON.parse(localStorage.getItem("Register Details")) || null;
  // const token = localStorage.getItem("auth_token");

  const location = useLocation();
  const isPrintPage =
    location.pathname.startsWith("/student/admission/payment") ||
    isAdmissionPage ||
    location.pathname.startsWith(
      "/admission/student/admission/payment/success"
    ) ||
    location.pathname.startsWith(
      "/admission/student/admission/payment/failed"
    ) ||
    location.pathname.startsWith("/student/admission-form/bsc/part-1") ||
    location.pathname.startsWith("/admission-form/print/") ||
    location.pathname.startsWith("/admission/student/payment/success") ||
    location.pathname.startsWith("/admission/student/payment/failed") ||
    location.pathname.startsWith("/student/dashboard") ||
    location.pathname.startsWith("/chalan-receipt/print") ||
    location.pathname.startsWith("/student/payment") ||
    location.pathname.startsWith("/admission/payment/print") || location.pathname.startsWith("/student/dashboard") || location.pathname.startsWith("/student/profile") || location.pathname.startsWith("/student/addmission") || location.pathname.startsWith("/student/chalan") || location.pathname.startsWith("/student/support");

  useEffect(() => {
    const fetchData = async () => {
      try {
        
        const response = await axios.get(
          "https://campus.acetians.in/api/v1/get-store-data"
        );
        const response2 = await axios.get(
          "https://campus.acetians.in/api/v1/get-store-sliders"
        );
        const response3 = await axios.get(
          "https://campus.acetians.in/api/v1/get-store-notices"
        );
        const response4 = await axios.get(
          "https://campus.acetians.in/api/v1/get-store-gallery"
        );
        const response5 = await axios.get(
          "https://campus.acetians.in/api/v1/get-course-data"
        );
        const response6 = await axios.get(
          "https://campus.acetians.in/api/v1/get-useful-links"
        );
        const response7 = await axios.get(
          "https://campus.acetians.in/api/v1/get-staffs"
        );

        dispatch({ type: "SET_STORE_DATA", payload: response.data });
        setStore(response.data);
        dispatch({ type: "SET_STORE_SLIDERS", payload: response2.data });
        dispatch({ type: "SET_NOTICES", payload: response3.data });
        dispatch({ type: "SET_GALLERY_IMAGES", payload: response4.data });
        const gal = [...new Set(response4.data.map((e) => e.title))];
        setGalleryHeads(gal);
        dispatch({ type: "SET_COURSE_DATA", payload: response5.data });
        dispatch({ type: "SET_LINK", payload: response6.data });
        dispatch({ type: "SET_STAFF", payload: response7.data });
        const strm = [...new Set(response7.data.map((e) => e.stream))];
        setStreams(strm);
      } catch (error) {
        // Handle errors
        console.error("Error fetching data", error);
      } finally {
        // Set loading to false after request completion
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        setPerc((prev) => {
          if (prev < 99) {
            return prev + 1;
          } else {
            clearInterval(interval);
            return prev;
          }
        });
      }, 40); // Adjust the interval time as needed
      return () => clearInterval(interval);
    } else {
      setPerc(100);
    }
  }, [loading]);

  const studentInformation = useSelector((state) => state.auth.studentData);

  return (
    <>

      <ScrollToTop />


      <div className="main">
        {!isPrintPage && <Navbar isLoading={loading} />}
        {loading == true ? (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div style={{ height: "200px", width: "200px" }}>
                <CircularProgressbar
                  color="secondary"
                  strokeWidth={3}
                  value={perc}
                  text={`${perc}%`}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="main-body">
            <Routes>
              {/* Home and Login */}
              <Route path="/" element={<Home />} />

              {/* Protected Routes */}
              <Route
                path="/counter"
                element={<ProtectedRoute component={<Counter />} />}
              />

              {/* Events  */}
              <Route path="/events/rover-rangers" element={<Events title="Rover Rangers" />} />
              <Route path="/events/nss" element={<Events title="Community Outreach Programs (NSS)" />} />

              <Route path="/events/games-sports" element={<Events title="Games & Sports" />} />

              {/* About Routes */}
              <Route path="/about/about-us" element={<AboutUsPage />} />
              <Route path="/about/our-history" element={<OurHistory />} />
              <Route path="/about/vision-mission" element={<Vision />} />
              <Route
                path="/about/we-value-their-services"
                element={<WeValues />}
              />
              <Route
                path="/about/we-value-their-services/our-past-principal"
                element={<WeValues />}
              />
              <Route
                path="/about/we-value-their-services/our-past-faculties"
                element={<WeValues />}
              />

              {/* Administration Routes */}
              <Route
                path="/administration/principals-message"
                element={<PrincipalMessage />}
              />
              <Route
                path="/administration/public-relations-officer"
                element={<PRO />}
              />
              <Route
                path="/administration/proctorial-board"
                element={<ProctorialBoard />}
              />
              <Route path="/administration/councils" element={<Commitees />} />
              <Route path="/administration/parishad" element={<Parishad />} />
              <Route path="/administration/iqac" element={<IQAC />} />
              <Route
                path="/administration/rules-and-regulations"
                element={<Rules />}
              />
              <Route
                path="/administration/rules-and-regulations/ugc-regulation-2018"
                element={<Rules />}
              />
              <Route path="/administration/rusa" element={<RUSA />} />

              {/* Faculty & Staff Routes */}
              {streams.map((e) => (
                <Route
                  key={e.id}
                  path={`/faculties-staffs/${e
                    .toLowerCase()
                    .replace(/ /g, "-")
                    .replace(/[^\w-]+/g, "")
                    .replace(/--+/g, "-")
                    .replace(/^-+|-+$/g, "")}`}
                  element={<Faculty stream={e} />}
                />
              ))}
              <Route path="/faculties-staff/faculty-of-arts" element={<Faculty stream="Humanities & Arts" />} />
              <Route path="/faculties-staff/faculty-of-science" element={<Faculty stream="Science" />} />
              <Route path="/faculties-staff/faculty-of-commerce" element={<Faculty stream="Commerce" />} />
              <Route path="/faculties-staff/non-teaching-staff" element={<Faculty stream="Office Staffs" />} />

              {/* Academic Routes */}
              <Route
                path="/academic/honors-awards-achievements"
                element={<Honors />}
              />
              <Route path="/academic/publications" element={<Publications />} />
              <Route
                path="/academic/academic-calendar"
                element={<AcademicCalendar />}
              />
              <Route
                path="/academic/list-of-holidays"
                element={<ListOfHoliday />}
              />
              <Route path="/academic/time-table" element={<Timetable />} />
              <Route
                path="/academic/ug-courses"
                element={<Courses name="ug" />}
              />
              <Route
                path="/academic/courses/science"
                element={
                  <Courses name="BSc. Bachelor of Science" categ="science" />
                }
              />
              <Route
                path="/academic/courses/commerce/"
                element={
                  <Courses name="BCom. Bachelor of Commerce" categ="commerce" />
                }
              />
              <Route
                path="/academic/other"
                element={<Courses name="Other Courses" categ="otherc" />}
              />
              <Route
                path="/academic/pg-courses"
                element={<Courses name="pg" />}
              />
              <Route
                path="/academic/teaching-plan"
                element={<TeachingPlan />}
              />
              <Route path="/academic/seminar" element={<Seminar />} />
              <Route path="/academic/workshop" element={<Workshop />} />
              <Route
                path="/academic/guest-lectures"
                element={<GuestLecture />}
              />
              <Route
                path="/academic/university-examination"
                element={<UniversityExamination />}
              />
              <Route path="/academic/research" element={<Research />} />
              <Route
                path="/academic/best-practices"
                element={<BestPractices />}
              />

              <Route
                path="/faculties/:id/:staffName"
                element={<FacultiesDetails />}
              />

              {!store?.facilities ? (
                <>
                  <Route
                    path="/facilities/multipurpose-hall"
                    element={<MultiPurposeHall />}
                  />
                  <Route
                    path="/facilities/smart-class-room"
                    element={<SmartClass />}
                  />
                  <Route
                    path="/facilities/women-health-club"
                    element={<WomenHealthClub />}
                  />
                  <Route
                    path="/facilities/computer-lab"
                    element={<ComputerLab />}
                  />
                  <Route path="/facilities/library" element={<Library />} />
                  <Route path="/facilities/e-library" element={<ELibrary />} />
                  <Route
                    path="/facilities/e-learning-park"
                    element={<ElearningPark />}
                  />
                  <Route
                    path="/facilities/college-store"
                    element={<CollegeStore />}
                  />
                </>
              ) : (
                store.facilities.map((e) => (
                  <Route
                    key={e.id}
                    path={`/facilities/${e.name
                      .toLowerCase()
                      .replace(/ /g, "-")
                      .replace(/[^\w-]+/g, "")
                      .replace(/--+/g, "-")
                      .replace(/^-+|-+$/g, "")}`}
                    element={<Facility facility={e} />}
                  />
                ))
              )}


              <Route path="/students/syllabus" element={<Syllabus />} />
              <Route path="/students/admission" element={<Admission />} />
              <Route
                path="/students/admission-rules"
                element={<AdmissionRules />}
              />

              {/* Gallery */}
              {gealleryHeads.map((e) => (
                <Route
                  key={e.id}
                  path={`/gallery/${e
                    .toLowerCase()
                    .replace(/ /g, "-")
                    .replace(/[^\w-]+/g, "")
                    .replace(/--+/g, "-")
                    .replace(/^-+|-+$/g, "")}`}
                  element={<Gallery galleryType={e} />}
                />
              ))}

              <Route
                path="/contact-us"
                element={<ContactUs title="Contact Us" />}
              />
              <Route path="/rankings/NIRF" element={<RankingNirf />} />
              <Route path="/rankings/NAAC" element={<RankingNirf />} />
              <Route
                path="/feedback-form"
                element={<FeedbackForm title="Feedback Form" />}
              />
              <Route
                path="/gallery/news"
                element={<Gallery galleryType="News" />}
              />

              {/* 404 Not Found */}
              <Route path="*" element={<PageNotFound />} />

              <Route path="/student/login" element={<LoginPage />} />

              <Route path="/student/forgot-password" element={<ForgotPass />} />

              <Route path="/student/register" element={<SudentRegister />} />

              <Route
                path="/student/dashboard"
                element={
                  <PrivateRoute>
                  <Home2 />
                  </PrivateRoute>
                }
              />

              <Route
                path="/student/payment"
                element={
                  <PrivateRoute>
                    <PaymentPage />
                  </PrivateRoute>
                }
              />

              <Route
                path="/student/admission/payment"
                element={
                  <PrivateRoute>
                    <AdmissionPayment student={studentInformation} />
                  </PrivateRoute>
                }
              />

              <Route
                path="/admission/student/payment/success"
                element={<Sucess />}
              />

              {/* <Route
                path="/student/dashboard"
                element={<Home2 />}
              /> */}

              <Route
                path="/student/profile"
                element={<Profile />}
              />

              <Route
                path="/student/addmission"
                element={<Addmission />}
              />

              <Route
                path="/student/chalan"
                element={<Chalan />}
              />

              <Route
                path="/student/supports"
                element={<Support />}
              />




              <Route
                path="/admission-form"
                element={
                  <FormPrivateRoute>
                    <AdmissionHomePage />
                  </FormPrivateRoute>
                }
              />
              <Route
                path="/admission/student/payment/failed"
                element={<Fail />}
              />
            
                <Route
                  path={`/student/admission-form/:courseName/:courseYear`}
                  element={
                    // <FormPrivateRoute>
                      <AdmissionBaseLayout
                        level={"hello"}
                        part={"Part-1"}
                        course={"hello"}
                        courseFullName={"c.name"}
                      />
                    // </FormPrivateRoute>
                  }
                />
            


        

              <Route path="/student/admission-form/bcom/part-1" element={<FormPrivateRoute><AdmissionBaseLayout part={"Part -1"} course={"BCOM"} courseFullName={"Bachelor of Commerce"} /></FormPrivateRoute>} />



              <Route
                path="/admission-form/print/:id"
                element={<AdmissionFormPrint />}
              />
              <Route
                path="/chalan-receipt/print/:id"
                element={<PrintComponent />}
              />
               <Route
                path="/chalan-receipt/print-v1/:id"
                element={<OnlineFeeChallan />}
              />
              <Route
                path="/chalan-receipt/print-v1/print/:id"
                element={<OnlineFeeChallan />}
              />

              <Route
                path="/admission/student/admission/payment/success"
                element={<Sucess />}
              />
              <Route
                path="/admission/student/admission/payment/failed"
                element={<Fail />}
              />

              <Route
                path="/admission/payment/print/:id"
                element={<AdmissionPaymentReceipt />}
              />
            </Routes>
          </div>
        )}
        {!isPrintPage && <Footer />}
      </div>
    </>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
